import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import OutcomeSelectorController from "./outcome_selector_controller"
application.register("outcome-selector", OutcomeSelectorController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)


import CheeseRainController from "./cheese_rain_controller"
application.register("cheese-rain", CheeseRainController)

import SelfFrameRelayController from "./self_frame_relay_controller"
application.register("self-frame-relay", SelfFrameRelayController)

import BetFeedbackController from "./bet_feedback_controller"
application.register("bet-feedback", BetFeedbackController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PushNotificationController from "./push_notification_controller"
application.register("push-notification", PushNotificationController)

import NotificationCenterController from "./notification_center_controller"
application.register("notification-center", NotificationCenterController)

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import PriceChartController from "./price_chart_controller"
application.register("price-chart", PriceChartController)

import SparklineController from "./sparkline_controller"
application.register("sparkline", SparklineController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)

import AdminSessionTimerController from "./admin_session_timer_controller"
application.register("admin-session-timer", AdminSessionTimerController)

import AdminDrawerController from "./admin_drawer_controller"
application.register("admin-drawer", AdminDrawerController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import FlashDismissController from "./flash_dismiss_controller"
application.register("flash-dismiss", FlashDismissController)

import PasswordRevealController from "./password_reveal_controller"
application.register("password-reveal", PasswordRevealController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import CommentReplyController from "./comment_reply_controller"
application.register("comment-reply", CommentReplyController)

import MissionsDropdownController from "./missions_dropdown_controller"
application.register("missions-dropdown", MissionsDropdownController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import AgeGateController from "./age_gate_controller"
application.register("age-gate", AgeGateController)

import LiveChatController from "./live_chat_controller"
application.register("live-chat", LiveChatController)

import InventoryFilterController from "./inventory_filter_controller"
application.register("inventory-filter", InventoryFilterController)

import JourneyFilterController from "./journey_filter_controller"
application.register("journey-filter", JourneyFilterController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import ConsentReopenController from "./consent_reopen_controller"
application.register("consent-reopen", ConsentReopenController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import LocaleDropdownController from "./locale_dropdown_controller"
application.register("locale-dropdown", LocaleDropdownController)

import MobileChatController from "./mobile_chat_controller"
application.register("mobile-chat", MobileChatController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import DominantColorController from "./dominant_color_controller"
application.register("dominant-color", DominantColorController)

import PostComposeController from "./post_compose_controller"
application.register("post-compose", PostComposeController)

import FeedDedupController from "./feed_dedup_controller"
application.register("feed-dedup", FeedDedupController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import PostCommentsController from "./post_comments_controller"
application.register("post-comments", PostCommentsController)

import AutoResizeController from "./auto_resize_controller"
application.register("auto-resize", AutoResizeController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import CpfMaskController from "./cpf_mask_controller"
application.register("cpf-mask", CpfMaskController)

import ReactionsController from "./reactions_controller"
application.register("reactions", ReactionsController)

import CommentModalController from "./comment_modal_controller"
application.register("comment-modal", CommentModalController)

import CommentFilterController from "./comment_filter_controller"
application.register("comment-filter", CommentFilterController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import RegistrationValidationController from "./registration_validation_controller"
application.register("registration-validation", RegistrationValidationController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PasswordRequirementsController from "./password_requirements_controller"
application.register("password-requirements", PasswordRequirementsController)

import GuestModalController from "./guest_modal_controller"
application.register("guest-modal", GuestModalController)

import CommentReplyFormController from "./comment_reply_form_controller"
application.register("comment-reply-form", CommentReplyFormController)

import FeedTabsController from "./feed_tabs_controller"
application.register("feed-tabs", FeedTabsController)

import HotMarketsScrollController from "./hot_markets_scroll_controller"
application.register("hot-markets-scroll", HotMarketsScrollController)

import UnfollowModalController from "./unfollow_modal_controller"
application.register("unfollow-modal", UnfollowModalController)

import TourneyCarouselController from "./tourney_carousel_controller"
application.register("tourney-carousel", TourneyCarouselController)

import AdMenuController from "./ad_menu_controller"
application.register("ad-menu", AdMenuController)

import AvatarCropController from "./avatar_crop_controller"
application.register("avatar-crop", AvatarCropController)

import CoverCropController from "./cover_crop_controller"
application.register("cover-crop", CoverCropController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import WalletSlidesController from "./wallet_slides_controller"
application.register("wallet-slides", WalletSlidesController)

import ToggleSettingController from "./toggle_setting_controller"
application.register("toggle-setting", ToggleSettingController)

import CpfSubmitController from "./cpf_submit_controller"
application.register("cpf-submit", CpfSubmitController)

import PasswordMatchController from "./password_match_controller"
application.register("password-match", PasswordMatchController)

import LikeToggleController from "./like_toggle_controller"
application.register("like-toggle", LikeToggleController)

import DmFormController from "./dm_form_controller"
application.register("dm-form", DmFormController)

import DmSendController from "./dm_send_controller"
application.register("dm-send", DmSendController)

import LogoutController from "./logout_controller"
application.register("logout", LogoutController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import VideoAutoplayController from "./video_autoplay_controller"
application.register("video-autoplay", VideoAutoplayController)

import TypingIndicatorController from "./typing_indicator_controller"
application.register("typing-indicator", TypingIndicatorController)

import InventoryController from "./inventory_controller"
application.register("inventory", InventoryController)

import CommentLikeController from "./comment_like_controller"
application.register("comment-like", CommentLikeController)

import CpfRevealController from "./cpf_reveal_controller"
application.register("cpf-reveal", CpfRevealController)

import NewConversationController from "./new_conversation_controller"
application.register("new-conversation", NewConversationController)

import DotlottiePlayerController from "./dotlottie_player_controller"
application.register("dotlottie-player", DotlottiePlayerController)

import PullRefreshController from "./pull_refresh_controller"
application.register("pull-refresh", PullRefreshController)

import DailyRewardController from "./daily_reward_controller"
application.register("daily-reward", DailyRewardController)

import ConversationsSearchController from "./conversations_search_controller"
application.register("conversations-search", ConversationsSearchController)

import GifPickerController from "./gif_picker_controller"
application.register("gif-picker", GifPickerController)

import TotemController from "./totem_controller"
application.register("totem", TotemController)

import QuizController from "./quiz_controller"
application.register("quiz", QuizController)

import PhoneCountryController from "./phone_country_controller"
application.register("phone-country", PhoneCountryController)

import UploadProgressController from "./upload_progress_controller"
application.register("upload-progress", UploadProgressController)

import ImageLoaderController from "./image_loader_controller"
application.register("image-loader", ImageLoaderController)

import TemplateFormController from "./template_form_controller"
application.register("template-form", TemplateFormController)

import TemplatePreviewController from "./template_preview_controller"
application.register("template-preview", TemplatePreviewController)

import RankingPoolController from "./ranking_pool_controller"
application.register("ranking-pool", RankingPoolController)

import HelpSearchController from "./help_search_controller"
application.register("help-search", HelpSearchController)

import HelpSearchServerController from "./help_search_server_controller"
application.register("help-search-server", HelpSearchServerController)

import BackController from "./back_controller"
application.register("back", BackController)

import EventRulesModalController from "./event_rules_modal_controller"
application.register("event-rules-modal", EventRulesModalController)

import EventPhasesController from "./event_phases_controller"
application.register("event-phases", EventPhasesController)

import RulesEditorController from "./rules_editor_controller"
application.register("rules-editor", RulesEditorController)

import EmailCampaignAudienceController from "./email_campaign_audience_controller"
application.register("email-campaign-audience", EmailCampaignAudienceController)

import EmailCampaignDispatchController from "./email_campaign_dispatch_controller"
application.register("email-campaign-dispatch", EmailCampaignDispatchController)

import ReferralShareController from "./referral_share_controller"
application.register("referral-share", ReferralShareController)

import ProfileShareController from "./profile_share_controller"
application.register("profile-share", ProfileShareController)

import EmailCampaignEditorController from "./email_campaign_editor_controller"
application.register("email-campaign-editor", EmailCampaignEditorController)
